import { render } from "./SlideshowSettings.vue?vue&type=template&id=91ced324&scoped=true"
import script from "./SlideshowSettings.vue?vue&type=script&lang=js"
export * from "./SlideshowSettings.vue?vue&type=script&lang=js"

import "./SlideshowSettings.vue?vue&type=style&index=0&id=91ced324&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ced324"]])

export default __exports__